import { useField } from 'formik';
import SuitCaseIcon from 'components/icons/SuitCaseIcon';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import Button from 'components/new-ui/base/button/Button';
import { CreateJobFormFields } from 'views/jobs/validationSchemas';
import { CreateJobFormSteps } from 'views/jobs/types';
import { generateJobReference } from './generateJobReference';

const fieldName = 'job.jobId';

const JobSection = () => {
    const [field, meta, helpers] = useField(fieldName);
    const { isIdle, isActive, isComplete, currentStepConfig, resetStep } =
        useMultiStepFormContext<CreateJobFormFields>();

    const stepKey = CreateJobFormSteps.JOB;
    const disabled = currentStepConfig?.disabled ?? false;

    const handleReset = () => {
        resetStep(stepKey, 'jobId');
    };

    // TODO:
    // This generating of reference id should be handled from the BE in the future
    // Raised the issue and this part of the code should be changed once the BE implements such API
    // At this time, there is no BE work item to link this TODO
    const handleGenerateId = () => {
        helpers.setValue(generateJobReference());
    };

    if (isIdle(stepKey)) {
        <div>
            <FormSectionHeader title="Job" icon={<SuitCaseIcon />} />
        </div>;
    }

    if (isActive(stepKey)) {
        return (
            <div>
                <FormSectionHeader
                    title="Job"
                    icon={<SuitCaseIcon />}
                    subtitle="You can create a custom Job ID or automatically create one"
                    button={<Button onClick={handleGenerateId}>Auto Job ID</Button>}
                />
                <FormInput
                    disabled={disabled}
                    inputStyles={{ maxWidth: '100%', marginTop: 6 }}
                    fieldProps={field}
                    fieldMeta={meta}
                    fieldHelper={helpers}
                    placeholder="Enter custom reference"
                />
            </div>
        );
    }

    if (isComplete(stepKey)) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <FormSectionHeader title="Job" icon={<SuitCaseIcon />} />
                <ReadonlyFormItem disabled={disabled} value={field.value} onReset={handleReset} />
            </div>
        );
    }

    return null;
};

export default JobSection;
